import { h } from 'preact';
import clsx from 'clsx';
import Image from 'utils/image';
import HeartIcon from 'utils/icon/icon-heart.svg';
import HeartIconFilled from 'utils/icon/icon-heart-filled.svg';

import CartIcon from 'utils/icon/icon-cart.svg';
import { decodeId, generateUrl } from './helpers';
import ProductBadge from '../product/product-badge';

const ProductCardShopTheLook = ({ productItem, ...props }) => {
  const product = productItem;

  const fl1ImageIndex = product.images.findIndex((image) =>
    image.src?.includes('FL1.'),
  );
  const imageIndexResult = !props.shopTheLook.showFlatImage
    ? 0
    : fl1ImageIndex === -1
    ? 0
    : fl1ImageIndex;

  const cardImage = product.images[imageIndexResult];

  const quickViewHandle = (e) => {
    if (
      !e.target.parentElement.classList.contains('wishlist-icon') &&
      !e.target.classList.contains('wishlist-icon')
    ) {
      document.dispatchEvent(
        new CustomEvent('quick-view:open', {
          detail: {
            handle: product.handle,
          },
        }),
      );
    }
  };

  return (
    <article
      className="relative group cursor-pointer product-card--shop-the-look"
      onClick={quickViewHandle}
    >
      <div className="relative">
        <div className="block no-underline pb-[137%]">
          {cardImage && (
            <span className="absolute inset-0">
              <Image
                {...cardImage}
                srcWidths={{ sm: 640 }}
                classes="object-cover h-full w-full"
              />
            </span>
          )}
        </div>
        <button
          className={clsx(
            'group swym-button swym-add-to-wishlist-view-product !text-default !p-0 !h-auto !absolute !right-10 !top-10 lg:!hidden lg:group-hover:!inline-block hidden',
            `product_${decodeId(product.id, 'Product')}`,
          )}
          data-with-epi="true"
          data-swaction="addToWishlist"
          data-product-id={decodeId(product.id, 'Product')}
          data-variant-id={decodeId(
            product?.variants?.[0].id,
            'ProductVariant',
          )}
          data-product-url={generateUrl(product.handle, 'products')}
        >
          <HeartIcon className="w-20 h-auto text-default heart-outline wishlist-icon" />
          <HeartIconFilled className="w-20 h-auto text-default heart-filled wishlist-icon" />
        </button>
        <button className="absolute z-20 bottom-8 right-8 items-center 
              lc:lg:right-16 lc:lg:bottom-16 bg-white lc:p-8 flex gap-4 lc:rounded-full lc:border border-grey-300 
              ml:p-8 ml:lg:p-8">
          <CartIcon className="w-16 h-auto lc:hidden" />
          <CartIcon className="w-16 h-auto ml:hidden" />
          <span className="body-6">
            {window.TMW.Strings.cart.add}
          </span>
        </button>
        <ProductBadge
          containerClassName={'absolute z-20 left-0 bottom-8 lc:min-h-[34px] ml:min-h-[24px] flex items-center max-w-[calc(100%-90px)]'}
          badges={product.badges?.value}
        />
      </div>
    </article>
  );
};

export default ProductCardShopTheLook;
